// Auto-import all translation files
import BottomNav from '../translations/BottomNav.json';
import HomePage from '../translations/HomePage.json';
import LoginPage from '../translations/LoginPage.json';
import RegisterPage from '../translations/RegisterPage.json';
import ResetPasswordPage from '../translations/ResetPasswordPage.json';
import FindSpotPage from '../translations/FindSpotPage.json';
import MySpotsPage from '../translations/MySpotsPage.json';
import ProfilePage from '../translations/ProfilePage.json';
import SpotRequestPage from '../translations/SpotRequestPage.json';
import AdminPage from '../translations/AdminPage.json';
import AdminLevelsPage from '../translations/AdminLevelsPage.json';
import FeedbackPage from '../translations/FeedbackPage.json';
import MarkFreePage from '../translations/MarkFreePage.json';
import SessionPage from '../translations/SessionPage.json';
import RegisterSpotPage from '../translations/RegisterSpotPage.json';
import SpotDetailPage from '../translations/SpotDetailPage.json';
import SchedulePage from '../translations/SchedulePage.json';
import NotFoundPage from '../translations/NotFoundPage.json';
import MaintenancePage from '../translations/MaintenancePage.json';
import Notifications from '../translations/Notifications.json';
import Components from '../translations/Components.json';
import ParkingAttributes from '../translations/ParkingAttributes.json';
import RecentClaimsPage from '../translations/RecentClaimsPage.json';
import NotificationPreferences from '../translations/NotificationPreferences.json';
import WelcomePage from '../translations/WelcomePage.json';
import SpotOwnerWizard from '../translations/SpotOwnerWizard.json';
import JoinBuildingPage from '../translations/JoinBuildingPage.json';
import Levels from '../translations/Levels.json';

export type Language = 'en' | 'he';

export interface TranslationEntry {
  key: string;
  en: string;
  he: string;
}

// Merge all translations into a flat namespace
const translations: Record<Language, Record<string, string>> = {
  en: {},
  he: {},
};

const allPages = [
  BottomNav,
  HomePage,
  LoginPage,
  RegisterPage,
  ResetPasswordPage,
  FindSpotPage,
  MySpotsPage,
  ProfilePage,
  SpotRequestPage,
  AdminPage,
  AdminLevelsPage,
  FeedbackPage,
  MarkFreePage,
  SessionPage,
  RegisterSpotPage,
  SpotDetailPage,
  SchedulePage,
  NotFoundPage,
  MaintenancePage,
  Notifications,
  Components,
  ParkingAttributes,
  RecentClaimsPage,
  NotificationPreferences,
  WelcomePage,
  SpotOwnerWizard,
  JoinBuildingPage,
  Levels,
];

allPages.forEach((page) => {
  (page as TranslationEntry[]).forEach((entry) => {
    translations.en[entry.key] = entry.en;
    translations.he[entry.key] = entry.he;
  });
});

export default translations;
